import functions from '../functions.js';
import { details } from './details';
import Slider from '../components/Slider';
import {DeparturePicker} from "../components/departure-picker";

$(() => {
    detailsPackage.init();
})

const detailsPackage = {
    $details: null,
    $form: null,
    form: null,
    enable: null,
    flights: null,
    prices: null,
    departures: null,
    calc: null,
    params: {
        objectId: null, 
        unitId: null, 
        guests: null, 
        dates: null,
        time: null,
        dateFrom: null,
        dateTo: null,
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: null,
        calcErrorMessages: null,
        dynamicPackage: 1,
        allowedServices: null,
        units: []
    },
    defaults: {
        guests: '2,0,0',
        dates: null,
        time: null,
        dateFrom: null,
        dateTo: null,
        aDateFrom: null,
        aDateTo: null,
        objectGroupId: 1,
        dynamicPackage: 1,
    },
    unitsTotal: 0,
    unitsTotalOld: 0,
    stopHashEvent: false,
    init() {

        this.$details = $('.object');

        if(! this.$details.length) {
            return;
        }

        this.params.objectGroupId = this.$details.attr('data-objectgroupid');

        if(! this.$details[0] || this.params.objectGroupId != 1) {
            return;
        }
        if(+this.$details.attr('data-dynamicpackage') != this.params.dynamicPackage) {
            return;
        }

        this.allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
        this.params.objectId = this.$details.attr('data-objectid');
        this.params.calcErrorMessages = $('[data-calcErrorMessages]')[0] ? JSON.parse($('[data-calcErrorMessages]').attr('data-calcErrorMessages')) : null;
        this.params.translations = $('[data-translations]')[0] ? JSON.parse($('[data-translations]').attr('data-translations')) : null;

        const $service = $('[name="serviceCode"]');

        this.getParams();

        if(this.params.dateFrom && this.params.dateTo) {
            $('.units-dates').text(functions.formatDate(this.params.dateFrom) + ' - ' + functions.formatDate(this.params.dateTo));
        }

        this.$form = $('form.availability-form');
        this.form = this.$form[0];

        this.stopHashEvent = false;
        $(window).on('hashchange', e => {
            if ( ! this.stopHashEvent) {
                this.calc = {};
                this.getParams();
                this.showFlightTickets();
                this.getCalculation();
            }
            this.stopHashEvent = false;
        });

        $.post('/services/dynamicPackageAvailability', {
            objectId: this.params.objectId,
            dynamicPackage: 1,
            language: functions.getLang(),
        }).always(response => {
            response = response ? JSON.parse(response) : null;
            if (response.status) {

                const prepared = this.getPackageDepartures(response.data.items, response.data.flights);
                const serviceCodes = response.data.serviceCodes;

                this.enable = prepared.enable;
                this.flights = prepared.flights;
                this.prices = prepared.prices;

                serviceCodes.forEach((serviceCode, key) => {
                    serviceCodes[key] = {
                        id: serviceCode,
                        text: serviceCode,
                    };

                    if ( ! this.params.serviceCode) {
                        this.params.serviceCode = serviceCode;
                    }
                });


                $("#details-datepicker").attr('data-departures', JSON.stringify(this.enable));
                $("#details-datepicker").attr('data-flights', JSON.stringify(this.flights));

                $("#details-datepicker").attr('data-prices', JSON.stringify(this.prices));

                $('.departure-picker-dynamic-package [data-input]').each((i, elem) => {
                    elem._departurePicker = new DeparturePicker(elem);
                });

                $service.select2({
                    data: serviceCodes,
                    minimumResultsForSearch: -1
                });

                setTimeout(() => {
                    $service.val(this.params.serviceCode).trigger('change');

                    $('[name="dateFrom"], [name="dateTo"], [name="guests"], [name="serviceCode"]').on('change', e => {
                        const data = functions.getFormData(this.$form);

                        this.params.dateFrom = data.dateFrom;
                        this.params.dateTo = data.dateTo;
                        this.params.time = data.time;
                        this.params.guests = data.guests;
                        this.params.serviceCode = data.serviceCode;

                        functions.setUrlData({
                            'dateFrom': this.params.dateFrom,
                            'dateTo': this.params.dateTo,
                            'time': this.params.time,
                            'aDateFrom': this.params.aDateFrom,
                            'aDateTo': this.params.aDateTo,
                            'serviceCode': data.serviceCode,
                            'guests': this.params.guests
                        }, true, true);
                    });
                });

                this.setDefaultDeparture();
                functions.setFormData(this.form, this.params);

                this.showFlightTickets();

                this.stopHashEvent = true;

                functions.setUrlData({
                    'dateFrom': this.params.dateFrom,
                    'dateTo': this.params.dateTo,
                    'time': this.params.time,
                    'aDateFrom': this.params.aDateFrom,
                    'aDateTo': this.params.aDateTo,
                    'serviceCode': this.params.serviceCode,
                    'guests': this.params.guests
                }, true, true);

                this.getCalculation();
            }
        })

        $('form.availability-form').on('submit', e => {
            e.preventDefault();
            const $target = $(e.currentTarget);
            const data = functions.getFormData($target);

            this.params.dateFrom = data.dateFrom;
            this.params.dateTo = data.dateTo;
            this.params.time = data.time;
            this.params.guests = data.guests;
            this.params.aDateFrom = data.aDateFrom;
            this.params.aDateTo = data.aDateTo;
            this.params.serviceCode = data.serviceCode;

            functions.setUrlData({
                'dateFrom': this.params.dateFrom,
                'dateTo': this.params.dateTo,
                'time': this.params.time,
                'aDateFrom': this.params.aDateFrom,
                'aDateTo': this.params.aDateTo,
                'guests': this.params.guests,
                'serviceCode': data.serviceCode
            }, true, true);
            //this.getCalculation();
        });

        $('.add-item').on('click', e => {
            let $target = $(e.target);
            $target = $target.attr('data-unitid') ? $target : $target.parents('[data-unitid]');
            let unitId = $target.attr('data-unitid');

            if(detailsPackage.calc[unitId] && detailsPackage.isBookable(detailsPackage.calc[unitId])) {
                let unitCalc = detailsPackage.calc[unitId].calc;
                let unitTotal = unitCalc.total;
                let totalOld = 0;

                unitCalc.items.forEach(item => {
                    if(item.itemType == 'baseRate') {
                        totalOld += item.itemTotal;
                    }
                });

                this.params.units.push({
                    'unitId': unitId,
                    'total': unitTotal,
                    'totalOld': totalOld > unitTotal ? totalOld : 0,
                });
            }

            detailsPackage.setCalSummary();

        });

        $('body').on('click','.remove-item',function(){
            let $target = $(this);
            $target = $target.attr('data-i') ? $target : $target.parents('[data-i]');
            const idx = $target.attr('data-i');

            detailsPackage.params.units = detailsPackage.params.units.filter((unit, i)=> {
                return i != idx;
            });

            detailsPackage.setCalSummary();
        });
    },
    isBookable(data, rateId = null) {
        return (data.booking.status == 'Request' || data.booking.status == 'Reservation') && (data.calc.status == 'Active' || data.calc.status == 'Request');
    },
    setCalSummary() {
        this.unitsTotal = 0;
        this.unitsTotalOld = 0;

        $('.units-rooms').text('');
        let cart = [];
        this.params.units.forEach((unit, i) => {
            unit.name = $('.unit-name[data-unitid=' + unit.unitId + ']').text();
            this.unitsTotal += unit.total;
            this.unitsTotalOld += unit.totalOld;

            let guests = 0;
            let adults = parseInt(this.params.guests.split(',')[0]);
            let kids = parseInt(this.params.guests.split(',')[1]);
            guests += adults + kids;

            $('.units-rooms').append('<div class="unit-room" data-unitid="' + unit.unitId + '" data-i="' + i + '"><button class="remove-item btn btn-dark px-1 py-0" data-unitid="' + unit.unitId + '"><i class="las la-times-circle la-lg text-danger"></i></button>' + unit.name + ', ' + guests + ' gosta</div>');

            cart.push({
                unitId : unit.unitId,
                dateFrom : this.params.dateFrom,
                dateTo : this.params.dateTo,
                aDateFrom : this.params.aDateFrom,
                aDateTo : this.params.aDateTo,
                time : this.params.time,
                serviceCode : this.params.serviceCode,
                guests : this.params.guests,
                dynamicPackage : 1
            })
        });

        $('.units-total').text(functions.formatMoney(this.unitsTotal, 0, '.', ','));
        if(this.unitsTotalOld > this.unitsTotal) {
            $('.units-total-old').text(functions.formatMoney(this.unitsTotalOld, 0, '.', ','));
        } else {
            $('.units-total-old').text('');
        }

        if (cart.length) {
            $('.btn-booking').attr('href',
                $('.btn-booking').attr('href').split('?')[0] +
                '?objectId=' + this.params.objectId +
                '&objectGroupId=' + this.params.objectGroupId +
                '&cart=' + JSON.stringify(cart)
            );

            $('.btn-booking').removeClass('disabled');
        } else {
            $('.btn-booking').addClass('disabled');
            $('.btn-booking').attr('href', $('.btn-booking').attr('href').split('?')[0]);
        }
    },

    getPackageDepartures(rates, flightTitles) {
        let departures = {};

        rates.forEach((rate) => {
            let unique = rate.dateFrom + ',' + rate.dateTo;

            let flight = rate.flight;
            let flightUnitId = flight.unitId;
            let unitId = rate['unitId']['id'];

            if ( ! departures[unique])
            {
                let flightIds = {};
                flightIds[flightUnitId] = {};
                flightIds[flightUnitId][unitId] = rate.id;

                let flights = {};
                flights[flightUnitId] = flight;

                let rates = {};
                rates[rate.id] = rate;
                if ( flight.timeDepartureFrom ) {
                    flight.time = flight.timeDepartureFrom + ',' + (flight.timeReturnFrom || '');
                }
                departures[unique] = {
                    'dateFrom'  : rate.dateFrom,
                    'dateTo'    : rate.dateTo,
                    'time'      : flight.time || null,
                    'aDateFrom'  : rate.aDateFrom,
                    'aDateTo'    : rate.aDateTo,
                    'isFlightAvailable' : rate.isFlightAvailable,
                    'duration'  : rate.accommodationDuration,
                    'flightIds' : flightIds,
                    'flights'   : flights,
                    'rates'     : rates
                };
            }
            else
            {
                let departure = departures[unique];

                if ( ! departure.flightIds[flightUnitId])
                {
                    let flightIds = {};
                    flightIds[flightUnitId] = {};
                    flightIds[flightUnitId][unitId] = rate.id;

                    departure.flightIds[flightUnitId] = {};
                    departure.flightIds[flightUnitId][unitId] = rate.id;
                }
                else if ( ! departure.flightIds[flightUnitId][unitId])
                {
                    departure.flightIds[flightUnitId][unitId] = rate.id;
                }

                departure.flights[flightUnitId] = flight;
                departure.rates[rate.id] = rate;
            }
        });

        this.departures = departures;
        //console.log(departures);

        let enable = [];
        let prices = {};
        let flights = [];

        Object.keys(departures).forEach(function(index) {

            let rate = departures[index];

            enable.push({
                dateFrom : rate['dateFrom'],
                dateTo : rate['dateTo'],
                duration: rate['duration'],
                time: rate['time'],
                aDateFrom : rate['aDateFrom'],
                aDateTo : rate['aDateTo'],
                isFlightAvailable : rate['isFlightAvailable']
            })

            prices[index] = detailsPackage.getDeparturePrices(rate);

            let arrival = rate.dateFrom;
            let departure = rate.dateTo;

            let arrivalDay = detailsPackage.getWeekDay(arrival);
            let arrivalDayDeparture = detailsPackage.getWeekDay(departure);

            Object.keys(rate.flights).forEach(function(index) {

                let flight = rate.flights[index];

                let flightUnitId = flight['unitId'];
                let rateIds = rate['flightIds'][flightUnitId];

                let timeDepartureFrom = flight['timeDepartureFrom'];
                let timeDepartureTo = flight['timeDepartureTo'];
                let timeReturnFrom = flight['timeReturnFrom'];
                let timeReturnTo = flight['timeReturnTo'];
                let placeFromName = flight['placeFrom'];
                let placeToName = flight['placeTo'];

                let flightTitle;
                let flightImage;
                flightTitles.forEach((ft) => {
                    if (ft.id == flight.objectId) {
                        flightTitle = ft.title;
                        flightImage = ft.image;
                    }
                });

                flights.push({
                    dateFrom              : rate.dateFrom,
                    dateTo                : rate.dateTo,
                    flightId              : flight.objectId,
                    flightTitle           : flightTitle,
                    flightImage           : flightImage,
                    flightUnitId          : flight.unitId,
                    rateIds               : rateIds,
                    arrivalDay            : arrivalDay,
                    arrivalDayDeparture   : arrivalDayDeparture,
                    timeDepartureFrom     : timeDepartureFrom,
                    timeDepartureTo       : timeDepartureTo,
                    timeReturnFrom        : timeReturnFrom,
                    timeReturnTo          : timeReturnTo,
                    time                  : flight.time,
                    aDateFrom             : rate.aDateFrom,
                    aDateTo               : rate.aDateTo,
                    placeFromName         : placeFromName,
                    placeToName           : placeToName,
                });
            });
        });

        return {
            enable : enable,
            prices : prices,
            flights : flights
        };
    },
    getWeekDay(date) {

        const d = new Date(date);
        const days = {
            "hr" : [
                "nedelja",
                "ponedeljak",
                "utorak",
                "sreda",
                "četvrtak",
                "petak",
                "subota"
            ],
            "sr" : [
                "nedelja",
                "ponedeljak",
                "utorak",
                "sreda",
                "četvrtak",
                "petak",
                "subota"
            ],
            "en" : [
                "Sunday ",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ]
        };

        let day = d.getDay()

        return days[functions.getLang()][day];
    },
    getDeparturePrices(rate) {
        let departurePrices = {};
        let flights = rate.flightIds;
        let rates = rate.rates;

        Object.keys(flights).forEach(function(flightId) {
            let items = flights[flightId];
            Object.keys(items).forEach(function(unitId) {
                let rateId = items[unitId];
                let unitRate = rates[rateId];

                if (unitRate) {

                    let validUntil = null;
                    if (unitRate.specialDiscount && unitRate.specialDiscount.validUntil) {
                        validUntil = unitRate.specialDiscount.validUntil;
                    }

                    var flightUnitId = flightId;

                    if ( ! departurePrices[unitId]) departurePrices[unitId] = {};

                    departurePrices[unitId][flightUnitId] = {
                        price : '€ ' + functions.formatMoney(unitRate.price, 0, '', ''),
                        priceWithDiscount : unitRate.priceWithDiscount ? ('€ ' + functions.formatMoney(unitRate.priceWithDiscount, 0, '', '')) : null,
                        discountTitle : unitRate.specialDiscount && unitRate.specialDiscount.itemDefinitionId.text ? unitRate.specialDiscount.itemDefinitionId.text : null,
                        validUntil : validUntil,
                        paymentKey : unitRate.paymentTypeKey == 'Once' ? 'po boravku' : 'po osobi'
                    };
                }
            });
        });

        return departurePrices;
    },
    showFlightTickets() {

        const dataFlights = JSON.parse($('[data-flights]').attr('data-flights'));


        let dateFrom = this.params.dateFrom;
        let dateTo = this.params.dateTo;

        let flights = dataFlights.filter(flight => {
            return flight.dateFrom == dateFrom && flight.dateTo == dateTo;
        });

        this.renderFlightTickets(flights);

        //$('.flight-ticket').addClass('d-none');
        
        //const $tickets = $('.flight-ticket[data-datefrom="' + dateFrom + '"][data-dateto="' + dateTo + '"]');
        //$tickets.removeClass('d-none');
        
        // set active ticket

        this.setFlightTicket(flights);
    },
    renderFlightTickets(flights) {
        const $flights = $('.flights').empty();
        flights.forEach((flight, index) => {
            /*$flights.append(`
                <div class="flight-ticket ${ index == 0 ? 'active' : '' } mb-3 pointer"
                    data-flight='${ JSON.stringify(flight) }' 
                    data-flightId="${ flight.flightId }"
                    data-flightUnitId="${ flight.flightUnitId }"
                    data-rateIds="${ flight.rateIds }"
                    data-dateFrom="${ flight.dateFrom }"
                    data-dateTo="${ flight.dateTo }">
                    <div class="row g-0">
                        <div class="col-12 bg-white rounded">
                            <div class="flight-title-wrapper px-4 pe-lg-5 py-2 bg-primary bg-opacity-25 rounded${ flight.flightTitle ? '' : ' d-none' }">
                                <h5 class="flight-title mb-0">${ flight.flightTitle }</h5>
                            </div>
                        </div>
                        <div class="col">
                            <div class="flight-ticket-body bg-white shadow rounded overflow-hidden">
                                <div class="row px-4 pe-lg-5 py-3">
                                    <div class="col-lg mb-3 mb-lg-0">
                                        <div class="d-flex justify-content-between mb-2">
                                            <div class="d-flex align-items-center">
                                                <i class="las la-plane-departure la-2x me-3"></i>
                                                <div class="text-muted fw-bold mb-0 text-uppercase me-2">ODLAZAK</div>
                                                <div class="d-flex align-items-end">
                                                    <div class="departure-date text-primary fw-bold mb-0" data-flight-DateFrom>${ functions.formatDate(flight.dateFrom) }</div>
                                                    <div class="departure-day small ms-2 lh-1 mb-1 text-uppercase" data-flight-DateFromDay>${ flight.arrivalDay }</div>
                                                </div>
                                            </div>
                                        </div>
                
                                        <div class="row">
                                            <div class="col-12 col-lg-auto d-flex flex-row flex-lg-column justify-content-between">
                                                <div class="departure-place-from small fw-bold mb-1 text-muted">${ flight.placeFromName }</div>
                                                ${ flight.timeDepartureFrom ? '<div class="departure-time-from h6 mb-0" data-flight-TimeDepartureFrom>' + flight.timeDepartureFrom + '</div>' : '' }
                                            </div>
                                            <div class="col-auto col-lg d-none d-lg-flex lign-items-center">
                                                <div class="w-100 bg-primary mt-2" style="height: 1px;"></div>
                                            </div>
                                            <div class="col-12 col-lg-auto text-end d-flex flex-row flex-lg-column justify-content-between">
                                                <div class="departure-place-to small fw-bold mb-1 text-muted">${ flight.placeToName }</div>
                                                ${ flight.timeDepartureTo ? '<div class="departure-time-to h6 mb-0" data-flight-TimeDepartureTo>' + flight.timeDepartureTo + '</div>' : '' }
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-auto">
                                        <div class="d-none d-lg-block h-100 bg-primary" style="width: 1px;"></div>
                                        <div class="d-block d-lg-none w-100 bg-primary mb-2" style="height: 1px;"></div>
                                    </div>
                                    <div class="col-lg">
                                        <div class="d-flex justify-content-between mb-2">
                                            <div class="d-flex align-items-center">
                                                <i class="las la-plane-departure la-2x me-3"></i>
                                                <div class="fw-bold text-muted mb-0 text-uppercase me-2">POVRATAK</div>
                                                <div class="d-flex align-items-center">
                                                    <div class="return-date fw-bold mb-0 text-primary" data-flight-DateTo>${ functions.formatDate(flight.dateTo) }</div>
                                                    <div class="return-day small ms-2 text-uppercase" data-flight-DateToDay>${ flight.arrivalDayDeparture }</div>
                                                </div>
                                            </div>
                                        </div>
                
                                        <div class="row">
                                            <div class="col-12 col-lg-auto d-flex flex-row flex-lg-column justify-content-between">
                                                <div class="return-place-from small fw-bold mb-1 text-muted">${ flight.placeToName }</div>
                                                ${ flight.timeReturnFrom ? '<div class="return-time-from h6 mb-0" data-flight-TimeReturnFrom>' + flight.timeReturnFrom + '</div>' : '' }
                                            </div>
                                            <div class="col-lg d-none d-lg-flex lign-items-center">
                                                <div class="w-100 bg-primary mt-2" style="height: 1px;"></div>
                                            </div>
                                            <div class="col-12 col-lg-auto text-end d-flex flex-row flex-lg-column justify-content-between">
                                                <div class="return-place-to small fw-bold mb-1 text-muted">${ flight.placeFromName }</div>
                                                ${ flight.timeReturnTo ? '<div class="return-time-to h6 mb-0" data-flight-TimeReturnTo>' + flight.timeReturnTo + '</div>' : '' }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-1">
                            <div class="ticket-tail shadow rounded d-flex justify-content-center align-items-center h-100 p-2">
                                <div class="bg-white border border-primary rounded-circle p-2">
                                    <i class="las la-check la-lg text-primary"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            `);*/

           $flights.append(`
                <div class="flight-ticket bg-white shadow mb-4 ${ index == 0 ? ' active' : '' }"
                    data-flight='${ JSON.stringify(flight) }' 
                    data-flightId="${ flight.flightId }"
                    data-flightUnitId="${ flight.flightUnitId }"
                    data-rateIds="${ flight.rateIds }"
                    data-dateFrom="${ flight.dateFrom }"
                    data-dateTo="${ flight.dateTo }">
            <div class="row no-gutters">
                <div class="col-lg-auto">
                    <div class="bg-primary d-flex justify-content-center align-items-center h-100 p-2 pb-4">
                        <div class="form-check">
                            <input class="form-check-input" type="radio"${ index == 0 ? ' checked' : '' }>
                        </div>
                    </div>
                </div>
                <div class="col">
                    <div class="px-4 py-3">
                        <div class="row">
                            <div class="col-lg">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <h3>Odlazak</h3>
                                        ${ flight.flightImage ? '<div style="min-height: 100px; background-size: contain; background-repeat: no-repeat; background-position: left;background-image:url('+flight.flightImage+')"></div>' : '' }
                                       </div>
                                    <div class="col-lg">
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <i class="las la-plane-departure la-2x mr-2"></i>
                                                <div class="d-flex align-items-end">
                                                    <div class="small mb-1 mr-2 text-uppercase" data-flight-DateFromDay>${ flight.arrivalDay }</div> 
                                                    <h5 class="mb-0" data-flight-DateFrom>${ functions.formatDate(flight.dateFrom) }</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-4">
                                            <div class="col-lg">
                                                ${ flight.timeDepartureFrom ? '<h3 class="mb-0" data-flight-TimeDepartureFrom>' + flight.timeDepartureFrom + '</h3>' : '' }
                                                <div class="small font-weight-bold">${ flight.placeFromName }</div>
                                            </div>
                                            <div class="col-lg d-flex align-items-center">
                                                <div class="w-100 bg-primary" style="height: 1px;"></div>
                                            </div>
                                            <div class="col-lg-auto d-flex flex-column justify-content-center text-center">
                                                <div class="small" data-flight-TimeFromDuration></div>
                                                <div><i class="las la-plane la-2x" style="transform: rotate(90deg);"></i></div>
                                                <div class="small">DIREKTAN</div>
                                            </div>
                                            <div class="col-lg d-flex align-items-center">
                                                <div class="w-100 bg-primary" style="height: 1px;"></div>
                                            </div>
                                            <div class="col-lg text-right">
                                                ${ flight.timeDepartureTo ? '<h3 class="mb-0" data-flight-TimeDepartureTo>' + flight.timeDepartureTo + '</h3>' : '' }
                                                <div class="small font-weight-bold">${ flight.placeToName }</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-auto">
                                <div class="h-100 bg-primary" style="width: 1px;"></div>
                            </div>
                            <div class="col-lg">
                                <div class="row">
                                    <div class="col-lg-3">
                                        <h3>Povratak</h3>
                                        ${ flight.flightImage ? '<div style="min-height: 100px; background-size: contain; background-repeat: no-repeat; background-position: left;background-image:url('+flight.flightImage+')"></div>' : '' }
                                    </div>
                                    <div class="col-lg">
                                        <div class="d-flex justify-content-between">
                                            <div class="d-flex align-items-center">
                                                <i class="las la-plane-departure la-2x mr-2"></i>
                                                <div class="d-flex align-items-end">
                                                    <div class="small mb-1 mr-2 text-uppercase" data-flight-DateToDay>${ flight.arrivalDayDeparture }</div> 
                                                    <h5 class="mb-0" data-flight-DateTo>${ functions.formatDate(flight.dateTo) }</h5>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row mt-4">
                                            <div class="col-lg">
                                                ${ flight.timeReturnFrom ? '<h3 class="mb-0" data-flight-TimeReturnFrom>' + flight.timeReturnFrom + '</h3>' : '' }
                                                <div class="small font-weight-bold">${ flight.placeToName }</div>
                                            </div>
                                            <div class="col-lg d-flex align-items-center">
                                                <div class="w-100 bg-primary" style="height: 1px;"></div>
                                            </div>
                                            <div class="col-lg-auto d-flex flex-column justify-content-center text-center">
                                                <div class="small" data-flight-TimeToDuration></div>
                                                <div><i class="las la-plane la-2x" style="transform: rotate(90deg);"></i></div>
                                                <div class="small">DIREKTAN</div>
                                            </div>
                                            <div class="col-lg d-flex align-items-center">
                                                <div class="w-100 bg-primary" style="height: 1px;"></div>
                                            </div>
                                            <div class="col-lg text-right">
                                                ${ flight.timeReturnTo ? '<h3 class="mb-0" data-flight-TimeReturnTo>' + flight.timeReturnTo + '</h3>' : '' }
                                                <div class="small font-weight-bold">${ flight.placeFromName }</div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>`);
        });
    },
    setFlightTicket(flights) {
        /*$('.flight-ticket').removeClass('active');
        if($tickets) {
            $tickets.addClass('active')
        }*/
        this.setUnitRateIds(flights[0]);

        $('.flight-ticket').on('click', e => {
            $('.flight-ticket').removeClass('active');
            const $target = $(e.currentTarget);
            $target.addClass('active');

            this.setUnitRateIds(JSON.parse($target.attr('data-flight')));
            this.getParams();
            this.getCalculation();
        });
    },
    setUnitRateIds(flight) {
        //console.log(flight);
        const rateIds = flight.rateIds;
        //console.log(rateIds);
        const flightId = this.params.flightId = flight.flightId;
        const flightUnitId = this.params.flightUnitId = flight.flightUnitId;
        Object.entries(rateIds).forEach(item => {
            const unitId = item[0];
            const rateId = item[1];

            $('.btn-booking[data-unitid=' + unitId + ']').attr('data-rateid', rateId);
            $('.btn-booking[data-unitid=' + unitId + ']').attr('data-flightid', flightId);
            $('.btn-booking[data-unitid=' + unitId + ']').attr('data-flightunitid', flightUnitId);
        })
    },
    initDepartureCalendar() {
        const $bookingCalendar = $('#booking-calendar-slider');

        if($bookingCalendar[0]) {
            const length = $bookingCalendar.find('.keen-slider__slide').length;
            const perView = 8;
            
            let slidesPerView = length < perView ? length : perView;

            if(length < perView) {
                $('.booking-calendar-wrapper').addClass('col-lg-' + (slidesPerView + 2));
                $('.booking-calendar-wrapper').addClass('mx-auto');
            }
    
            this.slider = new Slider($bookingCalendar, {
                // mode: 'snap',
                //centered: true,
                duration: 200,
                fade: false,
                loop: false,
                controls: false,
                initial: 0,
                arrows: functions.isMobile() || length > slidesPerView,
                slides: {
                    perView: slidesPerView,
                    spacing: 0,
                },
                breakpoints: {
                    '(min-width: 577px) and (max-width: 1024px)': {
                        controls: true,
                        arrows: length > 6,
                        //centered: true,
                        slides: {
                            perView: 6.2,
                        },
                    },
                    '(max-width: 576px)': {
                        controls: true,
                        arrows: length > 2,
                        //centered: true,
                        slides: {
                            perView: 2.2,
                        },
                    },
                },
            });
        }
    },
    setDefaultDeparture(departures) {

        this.params.dateFrom = ! this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateFrom : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom && this.departures ? this.departures[Object.keys(this.departures)[0]].dateTo : this.params.dateTo;

        if (this.departures && ! this.departures[this.params.dateFrom + ',' + this.params.dateTo]) {
            this.params.dateFrom = this.departures[Object.keys(this.departures)[0]].dateFrom;
            this.params.dateTo = this.departures[Object.keys(this.departures)[0]].dateTo;
        }

        let departure = this.departures ? this.departures[this.params.dateFrom + ',' + this.params.dateTo] : null;
        departure && (this.params.time = departure.time);
        departure && (this.params.aDateFrom = departure.aDateFrom);
        departure && (this.params.aDateTo = departure.aDateTo);

        /*this.params.dateFrom = ! this.params.dateFrom ? $('.departure[data-datefrom]').first().attr('data-datefrom') : this.params.dateFrom;
        this.params.dateTo = ! this.params.dateTo && this.params.dateFrom ? $('.departure[data-datefrom=' + this.params.dateFrom + ']').first().attr('data-dateto') : this.params.dateTo;
        let $first = $('.departure[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']');

        if(! $first.length) {
            this.params.dateFrom = $('.departure[data-datefrom]').first().attr('data-datefrom');
            this.params.dateTo = $('.departure[data-datefrom=' + this.params.dateFrom + ']').first().attr('data-dateto');
            $first = $('.departure[data-datefrom=' + this.params.dateFrom + '][data-dateto=' + this.params.dateTo + ']');
        }

        $('.departure').removeClass('active');
        $first.addClass('active');*/

        //this.params.guests = $('[name=guests]').val(); 

        //functions.setUrlData({ 'dateFrom': this.params.dateFrom, 'dateTo': this.params.dateTo, 'guests': this.params.guests }, true, true);

        //this.printDates();
    },
    getParams() {
        this.params = details.getParams(this.params, this.defaults);
        this.params.guests = this.params.guests && this.params.guests.startsWith('0') ? '2,0,0' : this.params.guests;
    },
    getCalculation(unitId = null) {

        const dateFrom = this.params.dateFrom;
        const dateTo = this.params.dateTo;
        const guests = this.params.guests;
        const serviceCode = this.params.serviceCode;

        if(
            (this.params.objectId || unitId)
            && guests
            && dateFrom
            && dateTo
            && this.params.objectGroupId
        ) {

            let guestsTotal = parseInt(guests.split(',')[0]) + parseInt(guests.split(',')[1]);

            return $.getJSON(
                location.protocol
                + '//'
                + location.hostname
                + '/services/calculation/'
                + (unitId ? '?unitId=' + unitId : '?objectId=' + this.params.objectId)
                + '&guests=' + guests
                + '&dateFrom=' + dateFrom
                + '&dateTo=' + dateTo
                + '&aDateFrom=' + this.params.aDateFrom
                + '&aDateTo=' + this.params.aDateTo
                + '&time=' + this.params.time
                + '&objectGroupId=' + this.params.objectGroupId
                + '&dynamicPackage=' + 1
                + (serviceCode ? '&serviceCode=' + serviceCode : '')
                + '&language=' + functions.getLang()
            )
                .done($.proxy(function (response) {

                    if(response.status) {
                        const data = response.data || [];
                        detailsPackage.calc = data;

                        Object.entries(data).forEach(unit => {
                            const unitId = unit[0];
                            const unitData = unit[1];

                            const $btnBooking = $('.btn-booking');

                            /*let unit = units.filter(unit => unit.unitId == unitId);
                            unit = unit[0];
                            if (unit)
                            {
                                unit.total = 0;
                                unit.totalOld = 0;
                            }*/

                            if(detailsPackage.isBookable(unitData)) {
                                const unitCalc = unitData.calc;

                                let unitTotal = unitCalc ? unitCalc.total : 0;
                                let unitTotalOld = null;

                                let total = unitCalc.currencySymbol;

                                unitCalc.items.forEach(item => {
                                    if(item.itemType == 'baseRate') {
                                        unitTotalOld = item.itemTotal;
                                        if(unitTotalOld > unitTotal) {
                                            total += '<del class="text-danger ml-2">' + functions.formatMoney(unitTotalOld, 0, '.', ',') + '</del>';
                                        }
                                    }
                                });

                                total += '<span class="ml-2">' + functions.formatMoney(unitTotal, 0, '.', ',') + '</span>';

                                $('.unit-price-total[data-unitid=' + unitId + ']').html(total);
                                $('.unit-price-total[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-total-price[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-container[data-unitid=' + unitId + ']').removeClass('d-none');
                                $('.unit-error-container[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-payment-type[data-unitid=' + unitId + ']').addClass('d-none');

                                $('.add-item[data-unitid=' + unitId + ']').removeClass('disabled');

                            } else {

                                $('.unit-error-container[data-unitid=' + unitId + ']').removeClass('d-none').html(details.getCalcErrorMessage(detailsPackage.params.calcErrorMessages, unitData));
                                $('.unit-price-container[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-total[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-total-price[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-from[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-price-night[data-unitid=' + unitId + ']').addClass('d-none');
                                $('.unit-payment-type[data-unitid=' + unitId + ']').addClass('d-none');

                                $('.add-item[data-unitid=' + unitId + ']').addClass('disabled');

                                $btnBooking.addClass('disabled');
                            }

                            //details.setCalSummary();

                        });
                    }

                }, window)).fail(function (error) {
                    console.log(error);
                });
        }

        else {
            $('.btn-booking').addClass('disabled');
        }

    },
    calculationDone(response) {

        if(response.status) {
            const data = response.data || [];

            //console.log(data);

            Object.entries(data).forEach(unit => {
                const unitId = unit[0];
                const unitData = unit[1];
                const $unit = $('.unit[data-unitid=' + unitId + ']');

                let discountTitle = null;

                if(detailsPackage.isBookable(unitData)) {
                    const unitCalc = unitData.calc;
                    const calcItems = unitCalc.items;
                    const total = unitCalc.total;
                    const currencySymbol = unitCalc.currencySymbol;

                    let priceOld = details.getCalcTotalOld(calcItems);
                    priceOld = +priceOld.toFixed(2);
                    discountTitle = details.getCalcDiscountTitle(calcItems);

                    if(discountTitle) {
                        //console.log(discountTitle);
                        $unit.find('.unit-price-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').text(discountTitle);
                        $unit.find('.fm-discount-title').toggleClass('d-none', false);
                    }

                    $unit.find('.unit-price-old').removeClass('d-none').text(priceOld > total ? currencySymbol + ' ' + functions.formatMoney(priceOld, 0, '.', ',') : '');
                    
                    //$unit.find('.unit-price-total-label').removeClass('d-none');
                    $unit.find('.unit-price-total').removeClass('d-none').text(currencySymbol + ' ' + functions.formatMoney(total, 0, '.', ','));
                    
                    //this.printDates();

                    const $btnBooking = $unit.find('.btn-booking[data-unitId=' + unitId + ']').removeClass('d-none');
                    //const rateId = $btnBooking.attr('data-rateid');
                    //const flightId = $btnBooking.attr('data-flightid');
                    const flightUnitId = $btnBooking.attr('data-flightunitid');

                    $btnBooking.text(unitData.booking.status == 'Request' ? $btnBooking.attr('data-requestLabel') : $btnBooking.attr('data-bookingLabel'));

                    if($btnBooking.attr('data-href')) {
                        $btnBooking.attr('data-href',
                            $btnBooking.attr('data-href').split('?')[0] +
                            '?objectGroupId=' + this.params.objectGroupId +
                            '&unitId=' + unitId +
                            '&dateFrom=' + this.params.dateFrom +
                            '&dateTo=' + this.params.dateTo +
                            '&guests=' + this.params.guests +
                            '&partnerId=' + this.params.partnerId +
                            '&addAllOptionals=1' + 
                            '&dynamicPackage=1' + 
                            '&flightUnitId=' + flightUnitId +
                            (this.params.serviceCode ? '&serviceCode=' + this.params.serviceCode : '') +
                            (this.params.time ? '&time=' + this.params.time : '') +
                            (this.params.aDateFrom ? '&aDateFrom=' + this.params.aDateFrom : '') +
                            (this.params.aDateTo ? '&aDateTo=' + this.params.aDateTo : '') +
                            '&language=' + functions.getLang()
                            //'&pricelistItemId=' + rateId
                        );
                    }

                    $btnBooking.on('click', e => {
                        e.preventDefault();
                        location = $(e.currentTarget).attr('data-href');
                    });

                    $unit.prop('style', 'order: ' + functions.formatMoney(total, 0, '', ''));

                    if(this.params.serviceCode) {
                        const allowedServices = JSON.parse($('[data-allowedservices]').attr('data-allowedservices'));
                        let serviceText = '';
                        allowedServices.forEach(item => {
                            if(item.key == this.params.serviceCode) {
                                serviceText = item.text;
                            }
                        });
                        $('.service-supplement').text(serviceText);
                    }

                } else {
                    $unit.prop('style', 'order: 10000;');
                }

                $unit.find('.unit-price-total-label').toggleClass('d-none', ! detailsPackage.isBookable(unitData));

                $unit.find('.unit-price-label').toggleClass('d-none', detailsPackage.isBookable(unitData));
                $unit.find('.unit-price').toggleClass('d-none', ! detailsPackage.isBookable(unitData));

                $unit.find('.unit-price-discount-title').toggleClass('d-none', ! detailsPackage.isBookable(unitData));
                $unit.find('.unit-price-payment-key').toggleClass('d-none', detailsPackage.isBookable(unitData));

                $unit.find('.fm-discount').toggleClass('d-none', discountTitle == null || ! detailsPackage.isBookable(unitData));
                
                $unit.find('.fm-discount-valid-until').toggleClass('d-none', detailsPackage.isBookable(unitData));
                //$unit.find('.fm-discount-valid-until-date').text(rate.validUntil ? rate.validUntil : '');

                $unit.find('.no-period-label').toggleClass('d-none', detailsPackage.isBookable(unitData));

                $unit.find('.btn-booking').toggleClass('d-none', ! detailsPackage.isBookable(unitData));

                //$unit.find('.btn-booking-container').toggleClass('d-none', ! detailsPackage.isBookable(unitData));
                //$unit.find('.btn-request-nobookable').toggleClass('d-none', detailsPackage.isBookable(unitData));

                let error = details.getCalcErrorMessage(this.params.calcErrorMessages, unitData);
                $unit.find('.unit-error-container').toggleClass('d-none', detailsPackage.isBookable(unitData));
                $unit.find('.unit-error-container').text(error);

                $unit.find('.availablility-label').toggleClass('d-none', unitData.message != 'notAvailable');
                $unit.find('.no-period-label').toggleClass('d-none', unitData.message == 'notAvailable' || detailsPackage.isBookable(unitData));

                $unit.find('.service-supplement').removeClass('d-none');
            });
        }
    },
    loader($target = null) {
        /*$target ? $target.addClass('active') : $('.unit-spinner').addClass('active');
        setTimeout(() => {
            $target ? $target.removeClass('active') : $('.unit-spinner').removeClass('active');
        }, 800);*/
    }
};
